// extracted by mini-css-extract-plugin
export default {"Indicator":"Indicator_Indicator__kYDpy","MoreInfo":"Indicator_MoreInfo__MZztq"};